import "./OrderSummary.scss";
import React from "react";

type Item = {
  productCode: string;
  designation: string;
  quantity: number;
  unitPriceHT: number;
  TVATaux: number;
};

type OrderSummaryProps = {
  items?: Item[];
  // deliveryFee: number;
};

const OrderSummary: React.FC<OrderSummaryProps> = ({
  items,
  // deliveryFee
}) => {
  const subTotal =
    items?.reduce((acc, item) => acc + item.unitPriceHT * item.quantity, 0) ??
    0;
  // const total = subTotal + deliveryFee;

  return (
    <div className="order-summary">
      <table>
        <thead>
          <tr>
            <th>Produits</th>
            <th>Qté</th>
            <th>Prix</th>
          </tr>
        </thead>
        <tbody>
          {items?.map((item, idx) => (
            <tr key={idx}>
              <td>{item.designation}</td>
              <td>{item.quantity}</td>
              <td>{item.unitPriceHT.toFixed(2)} €</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          {/* <tr className="line">
            <td colSpan={3}></td>
          </tr>
          <tr>
            <td>Sous-total (HT)</td>
            <td></td>
            <td>{subTotal.toFixed(2)} €</td>
          </tr>
          <tr>
            <td>Livraison</td>
            <td></td>
            <td>{deliveryFee.toFixed(2)} €</td>
          </tr> */}
          <tr className="line">
            <td colSpan={3}></td>
          </tr>
          <tr className="total">
            <td>
              <strong>Total (HT)</strong>
            </td>
            <td></td>
            <td>
              <strong>{subTotal.toFixed(2)} €</strong>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default OrderSummary;
